import React from "react";
import { func, object, arrayOf, string, bool } from "prop-types";

import { selectedFacetShape } from "../../../common/dynamicSearch.js";

import FilterDropdown from "../FilterDropdown/FilterDropdown.jsx";

const propTypes = {
  filterLabel: string,
  facets: arrayOf(object).isRequired,
  link: object,
  selectedFacets: selectedFacetShape.isRequired,
  onFacetChange: func.isRequired,
  onClearFacetGroup: func.isRequired,
  singleSelect: bool,
};

const FilterBar = (props) => {
  const {
    filterLabel,
    facets,
    onFacetChange,
    selectedFacets,
    onClearFacetGroup,
  } = props;

  // check if we need to render anything.
  const emptyFacets =
    !facets ||
    facets.length < 1 ||
    !facets.some((facet) => {
      return facet.values && facet.values.length > 0;
    });

  if (emptyFacets) {
    return null;
  }

  return (
    <section className="filter-bar">
      <div className="filter-bar__filter-menus">
        {facets &&
          facets.map((facet) => (
            <FilterDropdown
              key={facet.id}
              {...facet}
              filterLabel={filterLabel}
              onClearFacetGroup={onClearFacetGroup}
              selectedFacets={selectedFacets}
              onFacetChange={onFacetChange}
            />
          ))}
      </div>
    </section>
  );
};

FilterBar.propTypes = propTypes;
export default React.memo(FilterBar);
